(function () {
  'use strict';

  angular.module('app').component('bookingItemServiceItemPax', bookingItemServiceItemPax());

  function bookingItemServiceItemPax() {
    return {
      bindings: {
        // selectedItem: '=',
        bookingItemServiceItem: '=',
        bookingItem: '=',
        onBookingItemServiceItemPaxSaved: '&',
        onBookingItemServiceItemPaxCanceled: '&',
      },
      controller: BookingItemServiceItemPaxCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/booking-item-service-items/' +
        'components/booking-item-service-item-pax/booking-item-service-item-pax.component.html',
    };
  }

  BookingItemServiceItemPaxCtrl.$inject = ['UtilService'];

  function BookingItemServiceItemPaxCtrl(UtilService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    // Methods
    vm.saveBookingItemServiceItemPax = saveBookingItemServiceItemPax;
    vm.cancelBookingItemServiceItemPax = cancelBookingItemServiceItemPax;

    function saveBookingItemServiceItemPax() {
      vm.onBookingItemServiceItemPaxSaved({ bookingItemServiceItemObj: vm.bookingItemServiceItem });
    }

    function cancelBookingItemServiceItemPax() {
      vm.onBookingItemServiceItemPaxCanceled(); // { selectedItem: vm.selectedItem }
    }

    // , bookingItemServiceItemObj: vm.bookingItemServiceItem

    // vm.avoidNullValue = avoidNullValue;
    /*function avoidNullValue() {
            if (!vm.serviceItem.adults) {
                vm.serviceItem.adults = 0;
            }

            if (!vm.serviceItem.children) {
                vm.serviceItem.children = 0;
            }

            if (!vm.serviceItem.infants) {
                vm.serviceItem.infants = 0;
            }

            if (!vm.serviceItem.seniors) {
                vm.serviceItem.seniors = 0;
            }
        }*/
  }
})();
